import { ContentTypeFilterClause, ExplorableItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { DataConnectionContentType, WorkbookContentType } from '../ContentTypes';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { GenericCard } from '../../../app/spaces/CardView/GenericCard';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { Workbooks } from '../../../content/resources/Workbooks';

export const ConnectedWorkbooksInDatasourceDefinition: ExplorableItemDefinition = {
  itemType: 'connectedWorkbook',
  pluralName: Messages.connectedWorkbooks,
  emptyStateMessage: Messages.connectedWorkbooksEmptyMessage,
  contentFilterKeys: DataConnectionContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['connectedWorkbook']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return Workbooks.all().withExtraParams(WorkbookContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list', 'thumbnail'],
};
